import { Box, CloseButton, Divider, Heading } from '@customerio/pluma-components/react';
import type { ReactNode } from 'react';
import * as styles from './index.css';

export interface SidebarHeaderProps {
  title: ReactNode;
  leadingActions?: ReactNode;
  trailingActions?: ReactNode;
  onClose: () => void;
}

export function SidebarHeader({ title, leadingActions, trailingActions, onClose }: SidebarHeaderProps) {
  return (
    <>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        p="100"
        pl="200"
        className={styles.sidebarHeader}
      >
        <Box display="flex" alignItems="center" gap="100">
          {leadingActions}
          <Heading level="4">{title}</Heading>
        </Box>
        <Box display="flex" alignItems="center" gap="100">
          {trailingActions}
          <CloseButton onClick={onClose} />
        </Box>
      </Box>
      <Divider />
    </>
  );
}
